import React from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

/**
 * AccessGate — renders children only when `allowed` is truthy.
 * Otherwise shows a compact "Access Denied" panel that keeps the sidebar visible
 * (route is not unmounted). Message is contextual to the section.
 */
export default function AccessGate({ allowed, title = "Access restricted", message, children }) {
  if (allowed) return children;
  return (
    <div className="p-8 md:p-12" data-testid="access-denied">
      <div className="max-w-lg card-flat p-8 border-l-4 border-l-[var(--gold)]">
        <div className="flex items-center gap-2 overline mb-3"><Lock size={12} strokeWidth={1.5} /> Restricted</div>
        <h1 className="font-display text-3xl mb-3">{title}</h1>
        <p className="text-sm text-[var(--ink-2)] leading-relaxed mb-6">
          {message || "You do not have permission to view this section. Please ask an administrator to grant access."}
        </p>
        <Link to="/" className="btn-primary inline-block" data-testid="access-denied-home">Back to dashboard</Link>
      </div>
    </div>
  );
}
